import React from "react";
import OrderPage from "./components/OrderPage";
import { orderStatus } from "../../../constants/orderStatus";

const AutoRejected = () => {
  return (
    <div>
      <OrderPage type={orderStatus.autoRejected} />
    </div>
  );
};

export default AutoRejected;
